<template>
  <div style="padding: 0 8.3vw">
    <a-row type="flex" v-if="employee.investment_adviser[0]">
      <a-col class="team_employee" v-for="(item, index) in employee.investment_adviser"
             v-on:mouseover="employee.investment_adviser[index].active = true"
             v-on:mouseleave="employee.investment_adviser[index].active = false"
             :key="index">
        <img :src="item.picture" class="image">
        <h1 class="team_employee_name" v-if="employee.investment_adviser[index].active">
          {{ employee.investment_adviser[index].name_en }}</h1>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";
import {reactive, onMounted} from 'vue'

export default {
  name: 'Team_adviser_en',
  setup() {
    let employee = reactive({
      investment_adviser: [],
    })

    onMounted(() => {
      axios.get('https://sig-china.com:8081/api/employee/adviser')
          .then((res) => {
            for (let i = 0; i < res.data.length; i++) {
              employee.investment_adviser.push(res.data[i])
            }
            employee.investment_adviser.sort((a, b) => {
              return a['id'] - b['id']
            })
            for (let i = 0; i < employee.investment_adviser.length; i++) {
              employee.investment_adviser[i]['picture'] = 'https://sig-china.com' + employee.investment_adviser[i]['picture']
              employee.investment_adviser[i].active = false
            }
          })
    })

    return {employee}
  }
}
</script>
<style scoped>
.team_employee {
  width: auto;
  height: auto;
  align-items: center;
  justify-content: center;
  max-width: 20.8vw;
  position: relative;
}

.image {
  width: 20.8vw;
  height: auto;
  max-width: 20.8vw;
}

.team_employee_name {
  z-index: 2;
  position: absolute;
  bottom: 3vh;
  left: 2vw;
}

.image:hover {
  opacity: 0.5;
}

</style>
